import React, { useState, useEffect, useContext } from 'react'
import { NavigationContext } from '../NavigationContext'
import { useNavigate } from 'react-router-dom'

function Publikationen() {
  const [publications, setPublications] = useState([])
  const [loading, setLoading] = useState(true)
  const { setCurrentSlug } = useContext(NavigationContext)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchPublications = async () => {
      try {
        const response = await fetch('/wp-json/wp/v2/publikationen?_embed')
        const data = await response.json()
        
        if (Array.isArray(data)) {
          const formattedPublications = data.map(pub => ({
            id: pub?.id || '',
            title: pub?.title?.rendered || '',
            featuredImage: pub?._embedded?.['wp:featuredmedia']?.[0]?.source_url || '',
            slug: pub?.slug || ''
          }))
          setPublications(formattedPublications)
        }
        
        setLoading(false)
      } catch (error) {
        console.error('Error fetching publications:', error)
        setLoading(false)
      }
    }

    fetchPublications()
  }, [])

  const handlePublicationClick = (slug) => {
    const fullPath = `publikationen/${slug}`
    setCurrentSlug(fullPath)
    navigate(`/${fullPath}`)
  }

  return (
    <main className="publications-page">
      <h1 className="page-title">Publikationen</h1>
      
      <div className="publications-grid">
        {publications.map(pub => (
          <article 
            key={pub.id} 
            className="publication-card"
            onClick={() => handlePublicationClick(pub.slug)}
          >
            <div className="publication-image">
              {pub.featuredImage && (
                <img src={pub.featuredImage} alt={pub.title} />
              )}
              <div 
                className="publication-title"
                dangerouslySetInnerHTML={{ __html: pub.title }}
              />
            </div>
          </article>
        ))}
      </div>
    </main>
  )
}

export default Publikationen